import { constantsData, formFieldNamesData, optionsData } from "@/data";
import { AsyncDataKeyEnum, FieldTypeEnum, InputTypeEnum } from "@/enums";

const {
    conScoreConfigurations,
    dataSourceA,
    dataSourceB,
    exceptionConScoreThreshold,
    frequency,
    inReviewConScoreThreshold,
    matchedConScoreThreshold,
    name,
    rules,
} = constantsData.forms.reconciliations.reconciliation;

const {
    dataSourceA: dataSourceAFieldName,
    dataSourceB: dataSourceBFieldName,
    exceptionConScoreThreshold: exceptionConScoreThresholdFieldName,
    frequency: frequencyFieldName,
    inReviewConScoreThreshold: inReviewConScoreThresholdFieldName,
    matchedConScoreThreshold: matchedConScoreThresholdFieldName,
    name: nameFieldName,
    rules: rulesFieldName,
} = formFieldNamesData;

export const reconciliationFormData = [
    {
        description: name.description,
        isDisabled: true,
        label: name.label,
        name: nameFieldName,
        type: InputTypeEnum.TEXT,
    },
    {
        dataKey: AsyncDataKeyEnum.DATA_SOURCES,
        description: dataSourceA.description,
        isAsync: true,
        isDisabled: true,
        label: dataSourceA.label,
        name: dataSourceAFieldName,
        type: FieldTypeEnum.SELECT,
    },
    {
        dataKey: AsyncDataKeyEnum.DATA_SOURCES,
        description: dataSourceB.description,
        isAsync: true,
        isDisabled: true,
        label: dataSourceB.label,
        name: dataSourceBFieldName,
        type: FieldTypeEnum.SELECT,
    },
    {
        description: frequency.description,
        hasOptionFormat: true,
        label: frequency.label,
        name: frequencyFieldName,
        options: optionsData.reconciliation.frequencies,
        type: FieldTypeEnum.SELECT,
    },
    {
        description: conScoreConfigurations.description,
        fields: [
            {
                isMini: true,
                isOptional: true,
                label: exceptionConScoreThreshold.label,
                name: exceptionConScoreThresholdFieldName,
                type: InputTypeEnum.NUMBER,
            },
            {
                isMini: true,
                isOptional: true,
                label: inReviewConScoreThreshold.label,
                name: inReviewConScoreThresholdFieldName,
                type: InputTypeEnum.NUMBER,
            },
            {
                isMini: true,
                isOptional: true,
                label: matchedConScoreThreshold.label,
                name: matchedConScoreThresholdFieldName,
                type: InputTypeEnum.NUMBER,
            },
        ],
        isRowGroup: true,
        label: conScoreConfigurations.label,
    },
    {
        description: rules.description,
        hasOptionFormat: true,
        isDisabled: true,
        label: rules.label,
        name: rulesFieldName,
        options: [],
        type: FieldTypeEnum.SELECT,
    },
];
